export default __webpack_public_path__ + "static/media/reservoir-small.ea41d266.jpg";